import React, { useState, useContext, useEffect } from "react";

import { QueryParamsContext } from "../../context/QueryParamsContext";
import { find } from "../../repositories/qerpapi/erp/RouteRepository";

import { DialogContent, DialogTitle, DialogActions } from "@material-ui/core";

import Chip from "../../components/basics/Chip";
import TableDefault from "../../components/grid/TableDefault";
import TextField from "../../components/basics/TextFieldErp";

import {
  CustomDialog,
  StyledSearchDialog,
  Header,
  Body,
} from "./styles/SearchDialog";
import Btn from "../../components/buttons/Btn";

let typingTimer = null;

const SearchDialog = ({
  disabledSearch = false,
  disabledCancelButton = false,
  title,
  open,
  setOpen,
  multiSelect = true,
  selectable = true,
  route,
  include,
  filter,
  where,
  handleMainClick = () => {},
  columns,
  perPage = "250",
  page,
  sort,
  fields,
  rawUrl,
  rowId = "id",
  urlFilters = "",
  handleRequestArray = null,
  timeout = 1200,
}) => {
  const [dataRows, setDataRows] = useState([]);
  const [selected, setSelected] = useState([]);
  const [textFilter, setTextFilter] = useState("");
  const [loading, setLoading] = useState(false);

  const { queryParams } = useContext(QueryParamsContext);

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      try {
        setSelected([]);
        setLoading(true);

        const queryOrwhere = {};
        const queryUrlObjects = {};

        if (filter) {
          const arrQuery = filter.split(",");
          arrQuery.forEach((value, index) => {
            let text = "";
            if (value === "cpfcnpj") {
              text = textFilter.replaceAll(/[^0-9]/g, "");
              text = text === "" ? null : text;
            } else text = textFilter;

            queryOrwhere[value] = text;
          });
        } else {
          columns.forEach((row, index) => {
            let text = "";
            if (row.id === "cpfcnpj") {
              text = textFilter.replaceAll(/[^0-9]/g, "");
              text = text === "" ? null : text;
            } else text = textFilter;

            queryOrwhere[row.id] = text;
          });
        }

        if (urlFilters) {
          const arrUrlFilters = urlFilters.split(",");
          arrUrlFilters.forEach((filter) => {
            queryUrlObjects[filter] = `${textFilter}`;
          });
        }

        const callback = await find({
          empresaCnpj: queryParams.empresa_cnpj,
          path: route,
          fields,
          where,
          orWhere: queryOrwhere,
          include,
          sort,
          perPage,
          page,
          rawUrl,
          urlObjects: queryUrlObjects,
        });

        if (callback && callback.success) {
          const resultRequest = handleRequestArray
            ? handleRequestArray(callback.data)
            : callback.data;
          setDataRows(resultRequest);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }, timeout);
  }, [
    textFilter,
    queryParams.empresa_cnpj,
    columns,
    fields,
    filter,
    include,
    page,
    perPage,
    route,
    sort,
    where,
    rawUrl,
    urlFilters,
    handleRequestArray,
    timeout,
  ]);

  const closeDialog = () => {
    setOpen(false);
  };

  return (
    <CustomDialog
      fullWidth={true}
      maxWidth="lg"
      open={open}
      onClose={closeDialog}
      aria-labelledby="dialog-title"
    >
      <StyledSearchDialog>
        <DialogTitle id="dialog-title">
          <Header>
            <Chip bgcolor="primary" textcolor="white" label={title} />
          </Header>
        </DialogTitle>
        <DialogContent>
          <Body>
            {!disabledSearch ? (
              <TextField
                label="Busque por qualquer coluna presente na tabela."
                variant="filled"
                value={textFilter}
                setValue={setTextFilter}
              />
            ) : (
              <></>
            )}
            <TableDefault
              maxHeight="45vh"
              columns={columns}
              loading={loading}
              values={dataRows}
              selectable={selectable}
              multiSelect={multiSelect}
              selected={selected}
              setSelected={setSelected}
              tableTitle=""
              stickyHeader
              rowId={rowId}
              doubleTap={() => {
                handleMainClick(setOpen, selected);
              }}
            />
          </Body>
        </DialogContent>
        <DialogActions>
          <Btn
            onClick={() => handleMainClick(setOpen, selected)}
            label="Selecionar"
          />
          {!disabledCancelButton ? (
            <Btn
              onClick={closeDialog}
              bgcolor="grey"
              label="Cancelar"
              hovercolor="blue"
            />
          ) : (
            <></>
          )}
        </DialogActions>
      </StyledSearchDialog>
    </CustomDialog>
  );
};

export default SearchDialog;
